(() => {
  if (customElements.get('umax-homepage')) return;
  class UmaxHomepage extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      clearTimeout(this.offerTimer);
      this.revealObserver?.disconnect();
      this.abort = new AbortController();
      this.glassObserver?.disconnect();
      const panels = [...this.querySelectorAll('.home-application-glass')];
      const equaliseGlass = () => {
        if (!this.isConnected || !panels.length) return;
        panels.forEach(panel => panel.style.removeProperty('min-height'));
        const height = Math.ceil(Math.max(...panels.map(panel => panel.getBoundingClientRect().height)));
        panels.forEach(panel => panel.style.setProperty('min-height', `${height}px`));
      };
      let lastWidth = -1;
      const grid = this.querySelector('.home-applications-grid');
      if (grid && 'ResizeObserver' in window) {
        this.glassObserver = new ResizeObserver(entries => {
          const width = entries[0].contentRect.width;
          if (width !== lastWidth) { lastWidth = width; equaliseGlass(); }
        });
        this.glassObserver.observe(grid);
      }
      window.addEventListener('resize', equaliseGlass, {signal: this.abort.signal});
      document.fonts?.ready.then(equaliseGlass);
      equaliseGlass();
      const track = this.querySelector('.project-gallery-track');
      if (track) {
        const buttons = [...this.querySelectorAll('[data-project-slide]')];
        const updateArrows = () => buttons.forEach(button => {
          button.disabled = Number(button.dataset.projectSlide) < 0 ? track.scrollLeft <= 2 : track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
        });
        buttons.forEach(button => button.addEventListener('click', () => {
          const card = track.querySelector('.project-gallery-card');
          const step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap);
          track.scrollBy({left: step * Number(button.dataset.projectSlide), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
        }, {signal:this.abort.signal}));
        track.addEventListener('scroll', updateArrows, {passive:true,signal:this.abort.signal});
        window.addEventListener('resize', updateArrows, {signal:this.abort.signal});
        requestAnimationFrame(updateArrows);
      }
      const dialog = this.querySelector('dialog');
      if (!dialog) return;
      this.addEventListener('click', event => {
        if (event.target.closest('a[href="#warranty"]')) {
          const warranty = this.querySelector('#warranty');
          if (warranty) warranty.open = true;
        }
        if (event.target.closest('[data-open-offer]')) dialog.showModal();
        if (event.target.closest('[data-close-offer]')) dialog.close();
        if (event.target === dialog) {
          const box = dialog.getBoundingClientRect();
          if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
        }
      }, {signal: this.abort.signal});
      const expire = () => {
        this.dataset.offerActive = 'false';
        this.querySelectorAll('[data-promotion], [data-offer-countdown]').forEach(element => element.remove());
        this.querySelectorAll('[data-expired-copy]').forEach(element => { element.textContent = this.dataset.expiredMessage; });
        if (dialog.open) dialog.close();
        this.revealObserver?.disconnect();
      };
      const tick = () => {
        clearTimeout(this.offerTimer);
        if (this.dataset.offerActive !== 'true') return;
        const remaining = Date.parse(this.dataset.offerEnds) - Date.now();
        if (!Number.isFinite(remaining) || remaining <= 0) { expire(); return; }
        const counter = this.querySelector('[data-offer-countdown]');
        if (counter) {
          const hours = Math.floor(remaining / 3600000);
          const days = Math.floor(hours / 24), restHours = hours % 24;
          counter.querySelector('[data-countdown-value]').textContent = hours === 0 ? this.dataset.endingLabel : `${days} ${days === 1 ? this.dataset.dayLabel : this.dataset.daysLabel} · ${restHours} ${restHours === 1 ? this.dataset.hourLabel : this.dataset.hoursLabel}`;
          counter.hidden = false;
        }
        this.offerTimer = setTimeout(tick, Math.min(remaining, 60000));
      };
      tick();
      document.addEventListener('visibilitychange', tick, {signal: this.abort.signal});
      const gift = this.querySelector('.gift-band');
      if (gift && !gift.classList.contains('is-revealed') && !matchMedia('(prefers-reduced-motion: reduce)').matches && 'IntersectionObserver' in window) {
        this.revealObserver = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) { gift.classList.add('is-revealed'); this.revealObserver.disconnect(); }
        }, {threshold: 0.3});
        this.revealObserver.observe(gift);
      }
      document.addEventListener('shopify:section:unload', event => {
        if (event.target.contains(this)) dialog.close();
      }, {signal: this.abort.signal});
    }
    disconnectedCallback() { this.glassObserver?.disconnect(); this.abort?.abort(); clearTimeout(this.offerTimer); this.revealObserver?.disconnect(); }
  }
  customElements.define('umax-homepage', UmaxHomepage);
})();
